import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleDownSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-triangle-down-small, dropdown, caret"} maskId="square-filled-radius-0-stroke-1-IconChevronTriangleDownSmall"><path d="M7.91309 10.5L12.0002 15.2683L16.0873 10.5H7.91309Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronTriangleDownSmall;
